import useStore from './_store';
import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';

import { colorBlock } from '../defaultSpacing';
import { asyncData } from './async-data';
import { mapAsyncData } from '@/plugins/asyncData';
import spaceMixin from '@/modules/space-mixin';
import styleMixin from '@/modules/color-mixin';
import { getContactPointSchemaInfo } from '@/common/schemaInfo.js';


export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-agent-contact'
    },
    asyncData: mapAsyncData(asyncData),
    mixins: [spaceMixin(), styleMixin()],
    data: function() {
        return {
            title: '',
            displayMode: 'map',
            agentId: 0,
            bgType: '',
            bgColor: '',
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            showMap: true,
            loadMap: false,
            ...colorBlock,
            csmPhone: '',
            csmEmail: '',
            csmWebsite: '',
            csmAddress: '',
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png',
        };
    },
    props: {
        agentDetail: {
            type: Object,
            default: null
        },
        agentAddress: {
            type: String
        }
    },
    created() {
        if (this.agentDetail) {
            this.fullColumn = false;
            this.topSpacing = true;
            this.btmSpacing = true;
            this.showMap = false;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.loadMap = true;
        });
    },
    computed: {
        textAnimation() {
            return {
                name: 'appear-down',
                enable: this.showAnimationEffects
            }
        },
        fmtTitle({ title, totalCount }) {
            if (/{ *Count *}/.test(title)) {
                return title.replace(/{ *Count *}/g, totalCount);
            } else {
                return title;
            }
        },
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            siteType: store => store.page.siteType,
            rootAgents: store => store.agents,
            companyInfo: store => store.companyInfo
        }),
        isSubDomain({ siteType }) {
            //siteType is 3 explanation is Subdomain. For details, please refer to 'cms/src/common/siteInfo.js'
            return siteType == 3;
        },
        agent({ rootAgents, agentId = 0 }) {
            return rootAgents[agentId] || {};
        },
        phone({ agentDetail, agent, csmPhone }) {
            if (agentDetail?.phone) {
                return agentDetail.phone;
            }
            return csmPhone || agent.phone;
        },
        email({ agentDetail, agent, csmEmail }) {
            if (agentDetail?.email) {
                return agentDetail.email; 
            }
            return csmEmail || agent.email;
        },
        website({ agentDetail, agent, csmWebsite }) {
            if (agentDetail?.externalUrl) {
                return agentDetail.externalUrl
            }
            return  csmWebsite || agent.externalUrl;
        },
        address({ agentAddress, companyInfo, csmAddress, agent }) {
            if (agentAddress) {
                return agentAddress;
            }
            return csmAddress || agent.address || companyInfo.address;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        useBgSrc() {
            let pcSrc = this.getImageOpt(this.bgImgOpt.src);
            let mobileSrc = this.getImageOpt(this.bgImgOpt.mobileSrc);
            if (!this.isMobileSize) {
                return  pcSrc || mobileSrc;
            } else {
                return mobileSrc || pcSrc;
            }
        },
        isMobile() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobile ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobile ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        seoSchema({ page, agentDetail }) {
            const creatorInfo = agentDetail || page.agentCreator || {};

            if (!creatorInfo.phone && !creatorInfo.cellPhone && !creatorInfo.email) {
                return null;
            }

            // Get featured areas if available
            const featuredAreas = page.featuredAreas?.map(area => area.city || area.name).filter(Boolean) || [];

            return getContactPointSchemaInfo(creatorInfo, featuredAreas, {
                location: this.pageLocation
            });
        }
    },
    methods: {
        getImageOpt(src) {
            if (src && typeof src === 'object' && !src.imgUrl) {
                src = null;
            }
            return src;
        }
    }
};
